import { render, staticRenderFns } from "./RegisterView.vue?vue&type=template&id=7a545b56&scoped=true&"
import script from "./registerview?vue&type=script&lang=js&"
export * from "./registerview?vue&type=script&lang=js&"
import style0 from "../LoginView/loginView.scss?vue&type=style&index=0&id=7a545b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a545b56",
  null
  
)

export default component.exports